import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const SkeletonLoader = () => {
  return (
    <Skeleton
      width='100%'
      height={30}
      borderRadius={4}
      baseColor='var(--kt-skeleton-bg-color)'
      highlightColor='var(--kt-skeleton-highlight-bg-color)'
    />
  )
}

export default SkeletonLoader
